import { render, staticRenderFns } from "./aftersaleDetails.vue?vue&type=template&id=12fd8e37&scoped=true"
import script from "./aftersaleDetails.vue?vue&type=script&lang=ts"
export * from "./aftersaleDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd8e37",
  null
  
)

export default component.exports